import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINT } from '../config/keys'
import type { RootState } from '../store'

const baseQuery = fetchBaseQuery({
  baseUrl: API_ENDPOINT,
  prepareHeaders: (headers, { getState }) => {
    const accessToken = (getState() as RootState).auth.accessToken
    if (accessToken && accessToken !== 'fake') {
      headers.set('authorization', `Bearer ${accessToken}`)
    }
    headers.set('Content-Type', 'application/json')
    return headers
  },
})

const api = createApi({
  baseQuery,
  tagTypes: ['Payment', 'User', 'Vehicle', 'Notification'],
  endpoints: () => ({}),
  keepUnusedDataFor: 30,
  refetchOnMountOrArgChange: true,
})

export default api
